import React from 'react';

import Referrers from '../referrers/Referrers';

// Thin passthrough — the whole V1 "Basket Items" section lives inside
// <Referrers>. Kept as its own file so the Layout import surface doesn't
// change.
const Charts = ({ chartData, chartsLoading }) => (
  <Referrers referrerData={chartData} chartsLoading={chartsLoading} />
);

export default Charts;
